import React from "react";
import { makeStyles } from "tss-react/mui";
import Page from "src/components/Page";
import Hero from "./Hero";
import { websiteTitle } from "src/config";

const useStyles = makeStyles()(() => ({
    root: {},
}));

const HomeView = () => {
    const { classes } = useStyles();

    return (
        <Page className={classes.root} title={websiteTitle}>
            <Hero />
        </Page>
    );
};

export default HomeView;
